import CommonModal from "../CommonModel/CommonModal";
import Typography from "../Typography";
import Button from "../Button/Button";
import { DEFAULT_MODAL_DENIED, getModalDeniedContent } from "../../permissions/permissionMessages";

/**
 * Centralized “permission denied” modal — pass `permissionKey` for copy from
 * {@link ../../permissions/permissionMessages.js}, or override with `title` / `description`.
 *
 * @param {object} props
 * @param {boolean} props.isOpen
 * @param {() => void} props.onClose
 * @param {string} [props.permissionKey] — e.g. PERMISSION_KEYS.USERS_CREATE
 * @param {string} [props.title] — overrides resolved title when set
 * @param {string} [props.description] — overrides resolved description when set
 */
const PermissionDeniedModal = ({
  isOpen,
  onClose,
  permissionKey,
  title: titleProp,
  description: descriptionProp,
}) => {
  const { title, description } =
    permissionKey != null
      ? getModalDeniedContent(permissionKey, {
          title: titleProp,
          description: descriptionProp,
        })
      : {
          title: titleProp ?? DEFAULT_MODAL_DENIED.title,
          description: descriptionProp ?? DEFAULT_MODAL_DENIED.description,
        };

  return (
    <CommonModal isOpen={isOpen} onClose={onClose} title={title} width="max-w-md">
      <Typography variant="text1" className="text-text-secondary mb-4">
        {description}
      </Typography>
      <div className="flex justify-end">
        <Button type="button" variant="primary" onClick={onClose}>
          OK
        </Button>
      </div>
    </CommonModal>
  );
};

export default PermissionDeniedModal;
